<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import ExcelExport from "@/components/ExcelExport.vue";
import Swal from "sweetalert2";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Profit Analysis",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    ExcelExport
  },
  data() {
    return {
      clientCurrentPage: 1,
      clientPerPage: 10,
      serverPerPage: 50,
      filterSales:{
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        product: '',
        category: '',
        title: 'Profit Analysis from '+this.datefrom+' to '+this.dateto,
        page: 1,
        per_page: 50
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Profit Analysis Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Profit Analysis Report",
          active: true,
        },
      ],
      totalRows: 1,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "product",
          sortable: true,
          label: 'PRODUCT',
        },
        {
          key: "qty",
          sortable: true,
          label: 'QUANTITY',
        },
        {
          key: "SPrice_no",
          sortable: true,
          label: 'UNIT SELLING PRICE',
        },
        {
          key: "total_priceno",
          sortable: true,
          label: 'TOTAL SELLING PRICE',
        },
        {
          key: "BPrice_no",
          sortable: true,
          label: 'UNIT BUYING PRICE',
        },
        {
          key: "total_bpriceno",
          sortable: true,
          label: 'TOTAL BUYING PRICE',
        },
        {
          key: "discount",
          sortable: true,
          label: 'DISCOUNT',
        },
        {
          key: "profit",
          sortable: true,
          label: 'PROFIT',
        },
      ],
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("saledetails", ["SaveStatus","filterStatus", "SalesReportData", "SalesReportPagination", "SalesReportSummary"]),
    ...mapGetters("products", ["Products","Categories"]),

    rows() {
      return this.SalesReportPagination.total;
    },

    currentPage: {
      get() {
        return this.SalesReportPagination.current_page;
      },
      set(value) {
        this.handlePageChange(value);        
      }
    },

    perPage: {
      get() {
        return this.SalesReportPagination.per_page;
      },
      set(value) {
        this.serverPerPage = value;
        this.handlePageChange(1);        
      }
    },

    total_amount() {
      return this.SalesReportSummary ? this.SalesReportSummary.totalAmount : 0;
    },
    total_cost() {
      return this.SalesReportSummary ? this.SalesReportSummary.totalCost : 0;
    },
    total_discount() {
      return this.SalesReportSummary ? this.SalesReportSummary.totalDiscount : 0;
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.SalesReport ? this.SalesReport.length : 1;
  },  
  methods: {
    ...mapActions({
      FetchSalesReport: "saledetails/fetchSalesReportData",
      FetchProducts: "products/fetchProducts",
      FetchCategories: "products/fetchPCategories",

    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */

    addCommas() {
      this.editAmtData.paid = this.thousandSeperator(this.editAmtData.paid);
    },

    FetchSalesData() {
      const useServerPagination = this.filterSales.datefrom !== this.filterSales.dateto;

      let payload = {...this.filterSales};

      if (useServerPagination) {
        payload.page = 1;
        payload.per_page = this.serverPerPage;
      }

      this.FetchSalesReport(payload);
    },

    handlePageChange(newPage) {
      let payload = {
        ...this.filterSales,
        page: newPage,
        per_page: this.serverPerPage
      };
      this.FetchSalesReport(payload);
    },

    handleExportError() {
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "There was an error exporting the profits data. Please try again.",
        confirmButtonText: "OK",
      });
    }
  },
  created() {
    this.FetchSalesReport(this.filterSales);
    this.FetchProducts();
    this.FetchCategories();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">Profit analysis from {{filterSales.datefrom}} to {{filterSales.dateto}}</h3>
              </div>

            </div>
            <div class="row mb-2">
              <div class="col-md-3 form-group">
                <label>CATEGORIES</label>
                
                <model-list-select
                  :list="Categories ? [{id: '', catName: 'All Categories' },...Categories] : []"
                  v-model="filterSales.category"
                  option-value="id"
                  option-text="catName"
                  placeholder="Select Category"
                  @input="FetchSalesData()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <ExcelExport
                  endpoint="export_profits"
                  filename="profits_report.xlsx"
                  :payload="filterSales"
                  button-text="Export"
                  button-variant="info"
                  icon-class="fas fa-download"
                  @export-error="handleExportError"
                />
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                  type="date"
                  v-model="filterSales.datefrom"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input
                  v-model="filterSales.dateto"
                  type="date"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-3 form-group">
                <label>PRODUCT</label>
                
                <model-list-select
                  :list="Products ? [{id: '', name: 'All Products'},...Products] : []"
                  v-model="filterSales.product"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="FetchSalesData()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="FetchSalesData()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
            </div>
            <div>
              <table class="table table-striped table-bordered table-responsive nowrap w-100 datatables">
                <thead>
                <tr>
                  <th v-for="field in (fields)" :key="field.key">
                    {{ field.label }}
                  </th>
                </tr>
                </thead>
                <tbody v-if="!filterStatus && SalesReportData && SalesReportData.length > 0">
                <tr v-for="(item, index) in SalesReportData" :key="index">
                  <td>{{ SalesReportPagination.from + index }}</td>
                  <td>{{ item.date }}</td>
                  <td>{{ item.product }}</td>
                  <td>{{ item.qty }} {{ item.usymbol }}</td>
                  <td>{{ item.SPrice_no }}</td>
                  <td>{{ (item.SPrice*item.qty).toLocaleString() }}</td>
                  <td>{{ item.BPrice_no }}</td>
                  <td>{{ (item.BPrice*item.qty).toLocaleString() }}</td>
                  <td>{{ (item.discount).toLocaleString() }}</td>
                  <td>{{ ((item.SPrice*item.qty)-(item.BPrice*item.qty)+item.discount).toLocaleString() }}</td>
                </tr>
                </tbody>
                <tbody v-if="filterStatus">
                <tr>
                  <td :colspan="9" class="text-center">
                    <div class="text-warning my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </td>
                </tr>
                </tbody>
                <tbody v-if="!filterStatus && (!SalesReportData || SalesReportData.length === 0)">
                <tr>
                  <td :colspan="9" class="text-center">
                    No profits report data found for the selected criteria.
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col-md-3">
                <h5>Total Buying Price: <span class="text-danger">{{total_cost?(total_cost).toLocaleString():0}}</span></h5>
              </div>
              <div class="col-md-3">
                <h5>Total Selling Price: <span class="text-danger">{{total_amount?(total_amount).toLocaleString():0}}</span></h5>
              </div>
              <div class="col-md-3">
                <h5>Total Discount: <span class="text-danger">{{total_discount?(total_discount).toLocaleString():0}}</span></h5>
              </div>
              <div class="col-md-3">
                <h5>Total Profit: <span class="text-danger">{{total_amount?(total_amount-(total_cost+total_discount)).toLocaleString():0}}</span></h5>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
